export default __webpack_public_path__ + "static/products-fwfunctions-es-9a5fef7a175b16939c7b44eb1a8da6df.png";